import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const ExtendedFooterStyle = styled.div`
  .extended-footer {
    background-color: ${baseVariables.color['neutral10']};
  }
`;
